import { IPointingDtoOut } from '../../interfaces/garderie.interface';
import { INurserySettingsDTOOut } from '../../interfaces/nursery.interface';
import { INurseryHistoryPayload } from './../../interfaces/payloads/nursery.payloads';

// === NURSERY === //

export class GetNurseryHistory {
    public static readonly type = '[Nursery] get nursery history';
    constructor(public payload: INurseryHistoryPayload) {}
}

export class SearchPointing {
    public static readonly type = '[Pointing] search by date range';
    constructor(public payload: INurseryHistoryPayload) {}
}

export class GetNurserySettings {
    public static readonly type = '[Nursery] get nursery settings';
    constructor(public schoolId: number) {}
}

export class AddNursery {
    public static readonly type = '[Nursery] add nursery';
    constructor(public nursery: IPointingDtoOut) {}
}

export class DeleteNursery {
    public static readonly type = '[Nursery] delete nursery';
    constructor(public nurseryId: number) {}
}

export class UpdateNurserySettings {
    public static readonly type = '[Nursery] update nursery settings';
    constructor(public settings: INurserySettingsDTOOut, public id: number) {}
}

export class ResetNursery {
    public static readonly type = '[Nursery] reset state';
}

export class GetTotalOfPointingsByMonth {
    public static readonly type = '[Nursery] get total pointings by month';
}
